'use client';

import React from 'react';
import clsx from 'clsx';
import { IconSearchLg } from 'icon/General/search-lg';
import { isMac } from 'ui';

type SearchInputProps = {
  onValueChange: (value: string) => void;
  placeholder: string;
  value: string;
};
export function SearchInput({
  value,
  placeholder,
  onValueChange,
}: SearchInputProps) {
  return (
    <div className="flex items-center border-b px-3">
      <IconSearchLg className="me-2 size-5 shrink-0 text-placeholder" />
      <input
        className={clsx(
          'flex h-11 w-full rounded-md bg-transparent py-3 text-md text-primary outline-hidden placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50',
        )}
        onChange={(e) => {
          onValueChange(e.target.value);
        }}
        placeholder={placeholder}
        value={value}
      />
      <kbd className="pointer-events-none hidden select-none items-center gap-0.5 rounded-md border bg-secondary px-1.5 py-1 font-sans text-sm font-medium text-tertiary sm:inline-flex">
        <span className="">{isMac() ? '⌘' : 'Ctrl'}</span>K
      </kbd>
    </div>
  );
}
